<div *ngIf="reportType == 'InDetail'">
  <div id="print-section" class="container-fluid" style="width: 100%; overflow-x: auto;">
    <table class="table" style="width: 100%; table-layout: fixed; margin-top: 50px; font-size: 10pt;">
      <thead>
        <tr>
          <th colspan="3" class="header-cell">Vivek Saptahik</th>
          <th colspan="5" class="header-cell">Issue Seller Payment Receipt Ledger</th>
          <th colspan="4" class="header-cell">
            Date From: {{ startDate | date: 'dd-MM-yyyy' }} To: {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="3" class="sub-header-cell">Datewise</th>
          <th colspan="9" class="sub-header-cell">In Details</th>
        </tr>
        <tr>
          <th class="table-header" style="width: 120px;">Receipt No</th>
          <th class="table-header" style="width: 90px;">Receipt Date</th>
          <th class="table-header" style="width: 90px;">Entry Date</th>
          <th class="table-header">Issue Seller Name</th>
          <th class="table-header">Representative Name</th>
          <th class="table-header">Office Representative</th>
          <th class="table-header">Issue Name</th>
          <th class="table-header" style="width: 90px;">Issue-Date</th>
          <th class="table-header">Invoice Number</th>
          <th class="table-header" style="width: 90px;">Invoice Date</th>
          <th class="table-header text-right">Invoice Net Amount</th>
          <th class="table-header text-right">Received Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data of advtPaymentRegiInDetailsFormBeans">
          <tr>
            <td class="table-cell" style="width: 120px;">{{ data.rcpt_no }}</td>
            <td class="table-cell" style="width: 90px;">{{ data.rcpt_date }}</td>
            <td class="table-cell" style="width: 90px;">{{ data.entry_date }}</td>
            <td class="table-cell">{{ data.issue_seller_name }}</td>
            <td class="table-cell">{{ data.rep_name }}</td>
            <td class="table-cell">{{ data.off_rep_name }}</td>
            <td class="table-cell">{{ data.DS_ISSUENAME }}</td>
            <td class="table-cell" style="width: 90px;">{{ data.DS_ISSUEDATE }}</td>
            <td class="table-cell">{{ data.issue_invoice_no }}</td>
            <td class="table-cell" style="width: 90px;">{{ data.issue_invoice_date }}</td>
            <td class="table-cell text-right">{{ data.net_amt }}</td>
            <td class="table-cell text-right">{{ data.rcv_amt }}</td>
          </tr>
        </ng-container>
      </tbody>

      
        <tr>
          <td colspan="10" class="table-footer text-right">Total:</td>
          <td class="table-footer text-right">{{ PaymentadvtOffInDTotal_netamt }}</td>
          <td class="table-footer text-right">{{ PaymentadvtOffInDTotal1 | number: '1.2-2' }}</td>
        </tr>
      
    </table>
  </div>

  <div class="action-buttons noPrint" style="text-align: center; margin-top: 20px;">
    <button style="margin: 0 15px;" (click)="exportExcel('Payment_Receipt_Reg_InDetails_Report')" mat-raised-button color="primary">
      Export
    </button>
    <button style="margin: 0 15px;" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>
    <button style="margin: 0 15px;" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>
